<template>
  <div class="container-fluid login-bg">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <div class="card main-card">
            <div class="card-body">
                <div class="card-text">
                  <h2>Forgot Password</h2>
                  <p class="lead">
                     Enter your email to receive a password reset code
                  </p>
                  <div class="form-group">
                      <label for="email">Email</label>
                      <input type="text" class="form-control" name="email" v-model="email" v-validate="'required|email'" :class="{'has-error': errors.has('email')}" placeholder="Email">
                      <div v-if="errors.has('email')" class="alert alert-danger mt-1">
                        {{ errors.first('email') }}
                      </div>
                  </div>
                  <button v-on:click="login" type="submit" class="btn col-4 vesta-gray-btn">Submit</button>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.has-error {
  border-color: red;
}
</style>

<script>
/* eslint-disable */
import axios from 'axios'
export default {
    data() {
      return {
        email : '',
      }
    },
    methods: {
        login: function(e) {
            const vm = this;
            axios.post('/api/Account/ForgotPassword', {
                Email: this.email
            }).then(function (response) {
               vm.$router.push('ForgotPasswordConfirmation');
            })
            .catch(function (error) {
                vm.$router.push('ForgotPasswordConfirmation');
            });
        }
    }
}
</script>